export const safeOnComplete =
  (onSuccess, onError) =>
  (res, err) => {
    if (err || !res) {
      onError?.(err ?? { message: "Request failed. (safe On Complete)" });
      return;
    }

    onSuccess(res);
  };